/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setAccessRequestStoreBackOfficeFilter } from "../index";

export const useAccessRequestStoreBackOfficeFilterActions = () => {
  const dispatch = useDispatch();
  
  const updateFilter: any = ({ key, value }: { key: string; value: any }) => {
    dispatch(setAccessRequestStoreBackOfficeFilter({ key, value }));
  };

  return { updateFilter };
};